<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="background_color mb-5" >
              
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/mcustomer/index"> Manage Customer  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update Customer  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Update Customer </b></h6> -->
                <div class="container-fluid ">
                <div class="card ">
                <div class="card-body">


                    <form @submit.prevent="SaveCustomer()" >

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Dealer / Broker </label>
           
            <select @change="loadreopt1()"   class="form-select font-size_def" aria-label="Default select example" disabled>
              <option selected>Dealer</option>
              <option >Broker</option>
            
            </select>
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Sales Executive </label>
            <v-select label="value"  v-model="customer.area_agent" :options="salespeoples" ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Organization Name </label>
            <input  v-model="customer.C_name"  style="font-size: small;" class="form-control" required>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Bank Details</label>
            <input  v-model="customer.bank_details"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div>


<table style="font-size: small; " class="table   table-sm table-borderless  ">
<tbody >
                 

 

 <tr>

  <td style="width: 50%;">

<div class="row">
  <div class="col-md-6">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Address Line</label>
           
          

             <input
      class="form-control"
      v-model="searchAddress"
      placeholder="Search address"
      ref="autocomplete"
      />

       <input type="hidden" class="form-control" placeholder="Latitude" v-model="customer.lat" />
    <input type="hidden" class="form-control" placeholder="Longitude" v-model="customer.lng" />
    </div>
  </div>
  
 
 

  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Country</label>
            <input  v-model="customer.C_address_line4"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">District </label>
            <input  v-model="customer.district"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">AG Division</label>
            <input  v-model="customer.ag_division"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div>


<div class="row">
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">NIC No </label>
            <input  v-model="customer.nic_no"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">NIC</label>
            <input type="file"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Business Registration No </label>
            <input  v-model="customer.business_registration_no"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Business Registration Image</label>
            <input type="file"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div>


<div class="row">
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">VAT Number </label>
            <input  v-model="customer.vat_number"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">VAT certificate</label>
            <input type="file"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-check mt-4">
      <input class="form-check-input" type="checkbox"  v-model="customer.vat">
      <label class="form-check-label" for="flexCheckChecked">    VAT
      </label>
    </div>
  </div>
</div>

<div class="row mb-2">
  <div class="col-md-3">
    <div class="form-check ms-2">
    <input class="form-check-input" type="checkbox"  v-model="customer.parts">
      <label class="form-check-label" for="flexCheckChecked">   Parts
      </label>
  </div>
  </div>
  <div class="col-md-3">
    <div class="form-check ms-2">
    <input class="form-check-input" type="checkbox" v-model="customer.vehicle" >
      <label class="form-check-label" for="flexCheckChecked">    Vehicles
      </label>
  </div>
  </div>
</div>

  </td>

  <td>
   <div>
    <div v-if="mapUnavailable" class="customer-map customer-map-unavailable">
      <div class="customer-map-message">
        Map is unavailable in this browser session.
      </div>
    </div>
    <div v-else class="customer-map-shell">
      <div ref="map" id="map" class="customer-map"></div>
    </div>
  </div>

  </td>

 </tr>
 



</tbody>
</table>



    <h6 class="purchitem mb-2"><b>Add New Contact People</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead class="background_color2">
          <tr>
           
                <th>   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Contact Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Designation</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2">Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Mobile No</label>
                  </div>
                </th>
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in details" :key="detail.id">
                <input v-model="detail.id" type="hidden"  style="font-size: small;" class="form-control">
              <td><input v-model="detail.name"  style="font-size: small;" class="form-control" required></td>
              <td><input v-model="detail.designation" style="font-size: small;" class="form-control" ></td>
              <td><input v-model="detail.email"  style="font-size: small;" class="form-control" ></td>
              <td><input v-model="detail.tel" style="font-size: small;" class="form-control" required></td>
              
              
            </tr>
         
            
           



          
            
          </tbody>


        </table>
       
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Update</button>
    </div>
    </div>



</form>

<br><br>


                </div>
                </div>
           
            </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSalespeople();
    this.loadData();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            count: 0,
        total:0,
        selectedOption: null,
        'idcustomer':this.$route.query.id, // Store the selected option
     

      salespeoples:[

      ],
       map: null,
      marker: null,
      mapUnavailable: false,
      searchAddress: '',
        customer: {
        lat: null,
        lng: null,
        C_address_line1: ''
      },
      
        details:[],
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    

          async loadData() {
       
     
      try {
        const { data} = await  axios.get('/mcustomer/loadupdate?id='+this.idcustomer,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.customer = data.item_list;
          this.searchAddress = this.customer.C_address_line1;
          this.customer.lat = this.customer.latitude;
          this.customer.lng = this.customer.longitude;
        this.initMap(this.customer.latitude, this.customer.longitude);
         this.details = data.item_det;
      } catch (error) {
        console.log(error.response);
      }
    },

      initMap(lat, lon) {
        const leaflet = window.L;
        const fallbackLocation = { lat: 7.8731, lng: 80.7718 };
        const latitude = parseFloat(lat);
        const longitude = parseFloat(lon);
        const defaultLocation = (!Number.isNaN(latitude) && !Number.isNaN(longitude))
          ? { lat: latitude, lng: longitude }
          : fallbackLocation;

        if (!this.$refs.map || !leaflet) {
          this.mapUnavailable = true;
          return;
        }

        this.mapUnavailable = false;

        if (this.map && this.map.remove) {
          this.map.remove();
        }

        this.map = leaflet.map(this.$refs.map, {
          zoomControl: true
        }).setView([defaultLocation.lat, defaultLocation.lng], 13);

        leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors',
          maxZoom: 19
        }).addTo(this.map);

        this.marker = leaflet.marker([defaultLocation.lat, defaultLocation.lng], {
          draggable: true,
          icon: this.getMapMarkerIcon(leaflet)
        }).addTo(this.map);

        this.map.on("click", (event) => {
          const clickedLat = event.latlng.lat;
          const clickedLng = event.latlng.lng;
          this.setMapLocation(clickedLat, clickedLng);
          this.reverseGeocode(clickedLat, clickedLng);
        });

        this.marker.on("dragend", (event) => {
          const position = event.target.getLatLng();
          this.setMapLocation(position.lat, position.lng);
          this.reverseGeocode(position.lat, position.lng);
        });

        if (this.searchAddress) {
          this.searchLocation();
        } else {
          this.reverseGeocode(defaultLocation.lat, defaultLocation.lng);
        }

        setTimeout(() => {
          if (this.map && this.map.invalidateSize) {
            this.map.invalidateSize();
          }
        }, 0);
      },
     getMapMarkerIcon(leaflet) {
      return leaflet.icon({
        iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
    },
     setMapLocation(lat, lng) {
      const position = { lat: parseFloat(lat), lng: parseFloat(lng) };
      this.customer.lat = position.lat;
      this.customer.lng = position.lng;

      if (this.marker && this.marker.setLatLng) {
        this.marker.setLatLng([position.lat, position.lng]);
      }

      if (this.map) {
        this.map.setView([position.lat, position.lng], Math.max(this.map.getZoom ? this.map.getZoom() : 14, 14));
      }
    },

    async reverseGeocode(lat, lng) {
      this.isAddressLoading = true;
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lng)}`
        );
        const results = await response.json();

        if (results && results.display_name) {
          this.searchAddress = results.display_name;
          this.customer.C_address_line1 = results.display_name;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isAddressLoading = false;
      }
    },

    async searchLocation() {
      const address = String(this.searchAddress || '').trim();
      if (!address) {
        return;
      }

      this.isAddressLoading = true;
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&q=${encodeURIComponent(address)}`
        );
        const results = await response.json();
        const place = Array.isArray(results) ? results[0] : null;

        if (place) {
          const lat = parseFloat(place.lat);
          const lng = parseFloat(place.lon);
          this.setMapLocation(lat, lng);
          this.searchAddress = place.display_name || address;
          this.customer.C_address_line1 = this.searchAddress;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isAddressLoading = false;
      }
    },
          async loadSalespeople() {
       
     
      try {
        const { data} = await  axios.get('/msalespeople/salespeopleload',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.salespeoples = data.item_list;
        
        
      } catch (error) {
        console.log(error.response);
      }
    },

    async SaveCustomer() {
       
      console.log(this.customer);
      console.log(this.details);
    

       try {
         const { data} = await  axios.post('/mcustomer/update',{idcustomer:this.idcustomer, userid:this.userid,customer:this.customer,searchAddress:this.searchAddress,details:this.details},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/mcustomer/view?id='+this.idcustomer);
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

       

    },
    
    }
    
    </script>

    <style>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.customer-map {
  position: relative;
  width: 100%;
  height: 320px;
  min-height: 320px;
  border-radius: 10px;
  overflow: hidden;
  border: 0;
}

.customer-map-shell {
  position: relative;
  width: 100%;
  height: 320px;
  min-height: 320px;
  overflow: hidden;
  border-radius: 10px;
  background: #eef1f4;
}

.customer-map-shell .leaflet-container {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden;
}

.customer-map-shell #map.customer-map {
  height: 320px !important;
  min-height: 320px !important;
}

.customer-map-shell .leaflet-pane,
.customer-map-shell .leaflet-tile,
.customer-map-shell .leaflet-marker-icon,
.customer-map-shell .leaflet-marker-shadow,
.customer-map-shell .leaflet-tile-container,
.customer-map-shell .leaflet-pane > svg,
.customer-map-shell .leaflet-pane > canvas,
.customer-map-shell .leaflet-zoom-box,
.customer-map-shell .leaflet-image-layer,
.customer-map-shell .leaflet-layer {
  position: absolute;
  left: 0;
  top: 0;
}

.customer-map-shell .leaflet-tile,
.customer-map-shell .leaflet-marker-icon,
.customer-map-shell .leaflet-marker-shadow {
  user-select: none;
  -webkit-user-drag: none;
}

.customer-map-shell .leaflet-tile {
  width: 256px !important;
  height: 256px !important;
  max-width: none !important;
  max-height: none !important;
}

.customer-map-shell .leaflet-map-pane {
  z-index: 400;
}

.customer-map-shell .leaflet-tile-pane {
  z-index: 200;
}

.customer-map-shell .leaflet-overlay-pane {
  z-index: 400;
}

.customer-map-shell .leaflet-shadow-pane {
  z-index: 500;
}

.customer-map-shell .leaflet-marker-pane {
  z-index: 600;
}

.customer-map-shell .leaflet-tooltip-pane {
  z-index: 650;
}

.customer-map-shell .leaflet-popup-pane {
  z-index: 700;
}

.customer-map-shell .leaflet-control {
  position: relative;
  z-index: 800;
  pointer-events: auto;
}

.customer-map-shell .leaflet-top,
.customer-map-shell .leaflet-bottom {
  position: absolute;
  z-index: 1000;
  pointer-events: none;
}

.customer-map-shell .leaflet-top {
  top: 0;
}

.customer-map-shell .leaflet-right {
  right: 0;
}

.customer-map-shell .leaflet-bottom {
  bottom: 0;
}

.customer-map-shell .leaflet-left {
  left: 0;
}

.customer-map-shell .leaflet-control-zoom {
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.customer-map-shell .leaflet-control-zoom a {
  display: block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  background: #fff;
  color: #000;
  text-align: center;
  text-decoration: none;
}

.customer-map-loading {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  padding: 6px 10px;
  border-radius: 4px;
  background: #fff;
  color: #0d6efd;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.customer-map-unavailable {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f3f5;
  color: #495057;
  padding: 18px;
  text-align: center;
}

.customer-map-message {
  max-width: 320px;
  font-size: 13px;
  line-height: 1.4;
}

.customer-map-frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}
    </style>
    
